import ArticleList from "../components/ArticleList/ArticleList.js";

export default function Main() {
  return (
    <>
      <div
        style={{
          height: "700px",
          background: `url(${
            require("../assets/images/industrytop.png").default
          }) no-repeat center`,
        }}
      ></div>

      <div style={{ width: "1425px", margin: "20px auto" }}>
        <ArticleList catid="2" />
      </div>
    </>
  );
}
